<div class="row mt-24">
  <div class="col-12">
    <app-adx-erp-report-list/>
  </div>
</div>
